import React from "react";
import { FeaturesCode } from "./Allcomponents";
export default function Features_Home() {
  return (
    <div>
      <FeaturesCode />
    </div>
  );
}
